// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__ApScI","BarLogo":"Toolbar_BarLogo__2NfnL","DesktopOnly":"Toolbar_DesktopOnly__LuPaL"};